import { h } from 'vue'
import SvgIcon from './index.vue'
import { createSvgIcon } from './utils'
export * from './perfIcons/menu'
export * from './perfIcons/icons'
export {
  DownOutlined,
  RightOutlined,
  // DownOutlined,
  StarOutlined,
  StarFilled,
  PlusOutlined,
  // CloseOutlined,
  UserOutlined as OkrUserAim,
  EditOutlined,
  DeleteOutlined,
  SearchOutlined,
  MoreOutlined,
  CaretDownOutlined,
  ImportOutlined,
  LoadingOutlined,
  LeftOutlined,
  FileOutlined
} from '@ant-design/icons-vue'
export const APPLogoIcon = h(SvgIcon, {
    dir: 'app',
    name: 'logo'
  }),
  APPMenuIcon = h(SvgIcon, {
    dir: 'app',
    name: 'menu'
  })
export const OkrCommentOutlined = h(SvgIcon, {
    dir: 'okr',
    name: 'date'
  }),
  OkrLockOutlined = h(SvgIcon, {
    dir: 'okr',
    name: 'lock'
  }),
  OkrShareOutlined = h(SvgIcon, {
    dir: 'okr',
    name: 'share'
  }),
  OKrNormalMoreOutlined = h(SvgIcon, {
    dir: 'okr',
    name: 'more'
  }),
  OkrIconLockOutlined = h(SvgIcon, {
    dir: 'okr',
    name: 'okrLock'
  }),
  OkrImportOutlined = h(SvgIcon, {
    dir: 'okr',
    name: 'importOkr'
  }),
  OkrGuideIcon = h(SvgIcon, {
    dir: 'okr',
    name: 'guide'
  }),
  OkrBackendIcon = h(SvgIcon, {
    dir: 'okr',
    name: 'backend'
  }),
  OkrSelectIcon = h(SvgIcon, {
    dir: 'okr',
    name: 'select'
  }),
  OkrVisibleStatus = h(SvgIcon, {
    dir: 'okr',
    name: 'visible-status'
  }),
  OkrVisibleScore = h(SvgIcon, {
    dir: 'okr',
    name: 'visible-score'
  }),
  OkrVisibleWeight = h(SvgIcon, {
    dir: 'okr',
    name: 'visible-weight'
  }),
  OkrVisibleDate = h(SvgIcon, {
    dir: 'okr',
    name: 'visible-date'
  }),
  OkrCommentReplay = h(SvgIcon, {
    dir: 'okr',
    name: 'replay'
  }),
  OkrInputSearch = h(SvgIcon, {
    dir: 'okr',
    name: 'search'
  }),
  OkrUserListClose = () =>
    h(SvgIcon, {
      dir: 'okr',
      name: 'useListClose'
    }),
  OkrNormalCloseIcon = createSvgIcon({
    dir: 'okr',
    name: 'normalClose'
  }),
  OkrMorePointIcon = h(SvgIcon, {
    dir: 'okr',
    name: 'morePoint'
  }),
  OkrPlusIcon = h(SvgIcon, {
    dir: 'okr',
    name: 'plus'
  }),
  CloseOutlined = ()=> h(SvgIcon, {
    dir: 'okr',
    name: 'close'
  }),
  OkrRemoveIcon = h(SvgIcon, {
    dir: 'okr',
    name: 'remove'
  }),
  OkrEditIcon = h(SvgIcon, {
    dir: 'okr',
    name: 'edit'
  }),
  OkrSuccessIcon = h(SvgIcon, {
    dir: 'okr',
    name: 'success'
  }),
  OkrErrorIcon = h(SvgIcon, {
    dir: 'okr',
    name: 'error'
  }),
  OkrAuthLockIcon = h(SvgIcon, {
    dir: 'okr',
    name: 'authLock'
  }),
  ClockCircleOutlined = h(SvgIcon, {
    dir: 'okr',
    name: 'time'
  }),
  AdminLogoIcon = h(SvgIcon, {
    dir: 'common',
    name: 'admin-logo'
  }),
  AppCommonMoreIcon = h(SvgIcon, {
    dir: 'common',
    name: 'more'
  })